import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'reducers/modal/actions';
import styled from 'styled-components';

const { REACT_APP_NOTIFICATION_MODAL_DURATION_MS } = window.env;

const SnackBar = styled.div`
  min-width: 250px;
  margin-left: -125px;
  background: ${({ isSuccess }) =>
    isSuccess
      ? 'linear-gradient(180deg, #11b1d8 0%, #0779af 100%)'
      : '#EA6E6D'}; // Error results in red container
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 9999;
  right: 30px;
  top: 60px;

  -webkit-animation: fadein 0.5s,
    fadeout 0.5s ${REACT_APP_NOTIFICATION_MODAL_DURATION_MS / 1000 - 0.2}s;
  animation: fadein 0.5s,
    fadeout 0.5s ${REACT_APP_NOTIFICATION_MODAL_DURATION_MS / 1000 - 0.2}s;

  @-webkit-keyframes fadein {
    from {
      right: 0;
      opacity: 0;
    }
    to {
      right: 30px;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      right: 0;
      opacity: 0;
    }
    to {
      right: 30px;
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      right: 30px;
      opacity: 1;
    }
    to {
      right: 0;
      opacity: 0;
    }
  }

  @keyframes fadeout {
    from {
      right: 30px;
      opacity: 1;
    }
    to {
      right: 0;
      opacity: 0;
    }
  }
`;

const ConfirmationModal = () => {
  const dispatch = useDispatch();
  const displayModal = useSelector(state => state.modal.displayModal);
  const success = useSelector(state => state.modal.success);
  const message = useSelector(state => state.modal.message);

  useEffect(() => {
    if (displayModal) {
      setTimeout(
        () => dispatch(closeModal()),
        REACT_APP_NOTIFICATION_MODAL_DURATION_MS
      );
    }
  }, [displayModal, dispatch]);

  return (
    <>
      {displayModal ? (
        <SnackBar
          className={success ? 'success-modal' : 'fail-modal'}
          isSuccess={success}
        >
          {message}
        </SnackBar>
      ) : null}
    </>
  );
};

export default ConfirmationModal;
